import { useState } from 'react';

export const useAsyncConstructor = (callBack = async () => {}) => {
  const [hasBeenCalled, setHasBeenCalled] = useState(false);
  if (hasBeenCalled) return;
  setHasBeenCalled(true);
  callBack().then();
};
